import { Component, OnInit, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';


@Component({
  selector: 'app-aeronave-pj',
  templateUrl: './aeronave-pj.component.html',
  styleUrls: ['./../cadastral-pj/cadastral-pj.component.css','./aeronave-pj.component.css']
})
export class AeronavePjComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.aeronave===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.aeronave===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
